import React from "react";
import ReactDOM from "react-dom/client";
import "./services/axios-latest-only";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "./sass/index.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import { Slide, ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ProfileProvider } from "./context/ProfileContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
       <ProfileProvider>
        <BrowserRouter>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss
            draggable={true}
            pauseOnHover={false}
            theme="light"
            transition={Slide}
          />
        </BrowserRouter>
      </ProfileProvider>
    </Provider>
);
